/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, {  useState } from 'react'
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { GROUP_NAME, GROUP_NAME_ERROR, GROUP_NAME_INVALID, LABEL_BTN_CANCEL } from 'src/constants/constant';
import { TextField } from '@mui/material';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import '../Styles/muiglobal.css';
import { useSelector } from 'react-redux';
import type { RootState, GroupFormInputs, GroupApiResponse, appConfigs } from '../types/types';
import { addGroup } from 'src/services/groupService';
import GradientButton from '../MUICustomButton/GradientButton';
import OutlineButton from '../MUICustomButton/OutlineButton';


interface PropsType {
    closeModal: () => void;
    refreshPage: () => void;
}

function AddGroupForm({closeModal, refreshPage}: PropsType): JSX.Element {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const { user } = useSelector((state: RootState) => state.auth);
    
   const storedAppConfig = localStorage.getItem("appConfigs");
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  const parsedAppConfig = storedAppConfig
        ? (JSON.parse(storedAppConfig) as appConfigs[])
        : [];
 const CooldownMaxPeriod = parsedAppConfig.find(
        (item) => item.configName === "CooldownMaxPeriod")?.configValue;

const validationSchema = Yup.object().shape({
    groupName: Yup.string().required(GROUP_NAME_ERROR).matches(/^[A-Za-z0-9][A-Za-z0-9 ]*$/, GROUP_NAME_INVALID),
    cooldownPeriod: Yup.number()
        .nullable() // Allows null values
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        .transform((value, originalValue) => (originalValue === "" ? null : value)) // Converts empty string to null
        .typeError("Value must be a number")
        .min(1, "Value must be a positive integer")
        .test(
            'max-cooldown',
            `Value cannot be greater than ${CooldownMaxPeriod ?? 'maximum'} days`,
            function(value) {
                if (value == null) return true; // Skip validation if value is null
                if (CooldownMaxPeriod == null) return true; // Skip validation if max period is not set
                return value <= Number(CooldownMaxPeriod);
            }
        ),
});

    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm<GroupFormInputs>({
        resolver: yupResolver(validationSchema)
    });


    const onSubmit = async (data: GroupFormInputs): Promise<void> => {
        data.createdBy =  user?.id ?? 0;
        data.clientId = user?.clientId ?? 0;
        setIsLoading(true)
        await addGroup(data)
            .then(
                (res: GroupApiResponse) => {
                    console.log(res)
                    if(res.status === 200) {
                        if(res.data.result === 1) {
                            
                            NotificationManager.success("Group added successfully")
                            refreshPage()
                        } else if (res.data.messages === 'Campaign group was not added.') {
                            NotificationManager.error('Campaign group already exists');
                        }
                        else {
                            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                            NotificationManager.error("Unknown error has occurred");
                        }  
                    }
                }
            )
            .catch(
                error => {
                    console.log("error", error)
                    
                    NotificationManager.error("Unknown error has occurred")
                }
            )
            .finally(() => {
                console.log("done")
                setIsLoading(false)
            })
    }

    return (
        <React.Fragment>

            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    void handleSubmit(onSubmit)(e);
                }}
            >
                <div className="relative px-[16px] pt-[10px]">
                    <div className="mb-[30px]">
                        <Controller
                            name="groupName"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                            <>
                                <TextField
                                {...field}
                                fullWidth
                                label="Group Name*"
                                autoComplete="off"
                                
                                error={!!errors.groupName} // Set error state based on form validation
                                placeholder={GROUP_NAME}
                                />
                                {errors.groupName && (
                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                    {errors.groupName?.message} {/* Show the error message */}
                                </div>
                                )}
                            </>
                            )}
                        />
                    </div>
                    <div className="mb-[30px]">
                        <Controller
                            name="cooldownPeriod"
                            control={control}
                            render={({ field }) => (
                            <>
                                <TextField
                                    {...field}
                                    fullWidth
                                    label="Cooldown Period (days)"
                                    autoComplete="off"
                                    
                                    error={!!errors.cooldownPeriod}
                                    placeholder='Enter cooldown period in days'
                                />
                                {errors.cooldownPeriod && (
                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                    {errors.cooldownPeriod?.message} {/* Show the error message */}
                                </div>
                                )}
                            </>
                            )}
                        />
                    </div>
                </div>
                <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
                    <div className="w-full relative col-span-3">
                        {/* <button type='button' className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted" disabled={isLoading} onClick={closeModal}>{LABEL_BTN_CANCEL}</button> */}
                        <OutlineButton color='gray' borderRadius="0px" width='100%' height='48px' onClick={closeModal} disabled={isLoading} >{LABEL_BTN_CANCEL}</OutlineButton>
                    </div>
                    <div className="w-full relative col-span-3">
                        {/* <button type="submit" className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]">{!isLoading ? 'Save' : <span className="loading loading-spinner loading-xs text-white"></span>}</button> */}
                        <GradientButton type='submit' color='red' rounded={false} width='100%' height='48px' onClick={() => console.log('Button clicked')} disabled={isLoading} >{!isLoading ? 'Save' : <span className="loading loading-spinner loading-xs text-white" />}</GradientButton>
                    </div>
                </div>
            </form>


        </React.Fragment>
    )
}

export default AddGroupForm